import './js/modules/form'; //eslint-disable-line
import './js/main';
import 'aos/dist/aos.css';
import '@splidejs/splide/css';
import './css/input.css';
import './css/main.scss';
